module.exports = {"131025100":"平舒镇","131025101":"旺村镇","131025102":"大尚屯镇","131025103":"南赵扶镇","131025104":"留各庄镇","131025105":"权村镇","131025106":"里坦镇","131025107":"广安镇","131025200":"北魏乡","131025202":"臧屯乡","131025400":"河北大城经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131025.json
// module id = 237
// module chunks = 0